import { createAction, props } from '@ngrx/store';
import { EmployeeBaseRateStateItem } from './employee-base-rate.model';
import { EmployeeBaseRateUpdateRequest } from '../employee-base-rate.service';

export const getEmployeeBaseRates = createAction(
    '[EmployeeBaseRate/API] Get EmployeeBaseRates',
    (activeOnly: boolean = true) => ({ activeOnly })
);

export const loadEmployeeBaseRates = createAction(
    '[EmployeeBaseRate/API] Load EmployeeBaseRates',
    props<{ rows: EmployeeBaseRateStateItem[] }>()
);

export const putEmployeeBaseRate = createAction(
    '[EmployeeBaseRate/API] Put EmployeeBaseRate',
    props<{ request: EmployeeBaseRateUpdateRequest }>()
);

export const upsertEmployeeBaseRate = createAction(
    '[EmployeeBaseRate/API] Upsert EmployeeBaseRate',
    props<{ row: EmployeeBaseRateStateItem }>()
);

export const clearEmployeeBaseRates = createAction(
    '[EmployeeBaseRate/API] Clear EmployeeBaseRates'
);
